import request from '@/services/interceptor.js'

export const set_cliente = (par) => {
    return request({
        url: 'clienti/nuovo',
        method: 'post',
        data: par,
        loadingBar: true
    })
};


export const get_companyCode = () => {
    return request({
        url: 'clienti/companyCode',
        method: 'get',
    })
};


export const get_datiCliente = (par) => {
    return request({
        url: 'clienti/cliente/dati',
        method: 'post',
        data: par,
        loadingBar: true
    })
};


export const get_programmazione_audit = (par) => {
    return request({
        url: 'clienti/programmazione',
        method: 'post',
        data: par,
        loadingBar: true
    })
};


export const modifica_programmazione_audit = (par, tipo) => {
    return request({
        url: 'clienti/programmazione/' + tipo,
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const excel_programmazione_audit = (par) => {
    return request({
        url: 'clienti/programmazione/excel',
        method: 'post',
        data: par,
        loadingBar: true
    })
};


export const get_approvazioni_loghi = (par) => {
    return request({
        url: 'clienti/approvazioni-loghi',
        method: 'post',
        data: par,
        noLoadingBar: true
    })
};

export const salva_approvazione_logo = (par) => {
    return request({
        url: 'clienti/approvazioni-loghi/nuovo',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const aggiorna_approvazione_logo = (par) => {
    return request({
        url: 'clienti/approvazioni-loghi/aggiorna',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const elimina_approvazione_logo = (par) => {
    return request({
        url: 'clienti/approvazioni-loghi/elimina',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const excel_approvazioni_loghi = (anno) => {
    return request({
        url: 'clienti/approvazioni-loghi/excel?anno=' + encodeURIComponent(anno),
        method: 'post',
        loadingBar: true
    })
};